import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "campaign-standard",
  "use": "campaign-standard-usage",
  "viewBox": "0 0 48 49",
  "content": "<symbol viewBox=\"0 0 48 49\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"campaign-standard\"><path d=\"M22.2 32.258l10.42 13.91a3.328 3.328 0 005.932-1.382l7.2-38.346A3.326 3.326 0 0040.72 3L3.754 26.108a3.328 3.328 0 001.764 6.15H22.2zm0 0h-5V42.6a3.326 3.326 0 005.2 2.748l6.356-4.332-6.556-8.758zm-.002 0l22.16-29.18\" stroke=\"currentColor\" stroke-width=\"3\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/img/svg/campaign-standard.svg
// module id = K0c9
// module chunks = 39 44